import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from './Component';
/**
 * The camera component defines from which perspective the user views the scene.
 * The camera is commonly paired with controls components that allow input devices
 * to move and rotate the camera.
 *
 * @see https://aframe.io/docs/1.3.0/components/camera.html#sidebar
 */

export var Camera = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Camera, _Component);

  function Camera() {
    return _Component.apply(this, arguments) || this;
  }

  return Camera;
}(Component);